import apiClient from "../api/apiClient";

const analyzerService = {
  uploadImage: async (file, patient = {}) => {
    try {
      const recipientEmails = Array.isArray(patient.recipientEmails)
        ? patient.recipientEmails.filter(Boolean)
        : [];
      const formData = new FormData();
      formData.append("image", file);
      formData.append("email", patient.email || "");
      formData.append("name", patient.name || patient.fullName || "");
      formData.append("phone", patient.phone || "");
      formData.append("phoneNo", patient.phoneNo || patient.phone || "");
      formData.append("gender", patient.gender || "");
      formData.append("loggedInEmail", patient.loggedInEmail || patient.userEmail || "");
      formData.append("recipientEmails", JSON.stringify(recipientEmails));
      formData.append("ccEmails", JSON.stringify(recipientEmails));

      const response = await apiClient.post("/eyeAnalyzer/analyze", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log(response);
      
      return response.data;
    } catch (error) {
      console.error("Error uploading eye image:", error);
      throw error.response?.data || { message: "Image upload failed" };
    }
  },
  getSupplements: async (imgUrl, gptText, patient = {}) => {
    try {
      const recipientEmails = Array.isArray(patient.recipientEmails)
        ? patient.recipientEmails.filter(Boolean)
        : [];

      const response = await apiClient.post("/eyeAnalyzer/supplements", {
        imgUrl,
        gptText,
        email: patient.email || "",
        name: patient.name || patient.fullName || "",
        phone: patient.phone || "",
        phoneNo: patient.phoneNo || patient.phone || "",
        gender: patient.gender || "",
        loggedInEmail: patient.loggedInEmail || patient.userEmail || "",
        recipientEmails,
        ccEmails: recipientEmails,
      });

      return response.data;
    } catch (error) {
      console.error("Error while fetching supplements", error);
      throw error.response?.data || { message: "Image upload failed" };
    }
  },
};

export default analyzerService;
